import { render, staticRenderFns } from "./DeviceController.vue?vue&type=template&id=68f529de&scoped=true"
import script from "./DeviceController.vue?vue&type=script&lang=ts"
export * from "./DeviceController.vue?vue&type=script&lang=ts"
import style0 from "./DeviceController.vue?vue&type=style&index=0&id=68f529de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f529de",
  null
  
)

export default component.exports